import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantIncomeDetailsPage = {
  alert: {
    error: 'applicant-income-details-page.form.alert.error',
  },
  footer: {
    root: 'applicant-income-details-page.footer.root',
  },
  form: {
    amountInput: 'applicant-income-details-page.form.amount-input',
    amountInputError: 'applicant-income-details-page.form.amount-input-error',
    employerNameInput: 'applicant-income-details-page.form.employer-name-input',
    employerNameInputError:
      'applicant-income-details-page.form.employer-name-input-error',
    frequencySelect: 'applicant-income-details-page.form.frequency-select',
    frequencySelectError:
      'applicant-income-details-page.form.frequency-select-error',
    h1: 'applicant-income-details-page.form.h1',
    h2: 'applicant-income-details-page.form.h2',
    incomeTypeSelect: 'applicant-income-details-page.form.income-type-select',
    incomeTypeSelectError:
      'applicant-income-details-page.form.income-type-select-error',
    jobTitleInput: 'applicant-income-details-page.form.job-title-input',
    jobTitleInputError:
      'applicant-income-details-page.form.job-title-input-error',
    monthSelect: 'applicant-income-details-page.form.month-select',
    monthSelectError: 'applicant-income-details-page.form.month-select-error',
    root: 'applicant-income-details-page.form.root',
    submitButton: 'applicant-income-details-page.form.submit-button',
    yearSelect: 'applicant-income-details-page.form.year-select',
    yearSelectError: 'applicant-income-details-page.form.year-select-error',
  },
} as const satisfies PageLocatorMap;
